import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import Home from "./components/Home";
import About from "./components/About";
import Contact from "./components/Contact";
import Error from "./components/Error";
import Navigation from "./components/Navigation";

import './App.css';

class App extends Component {
	render() {
  
	  return (
		<BrowserRouter>
		  <Navigation/>
		  <Switch>
			<Route path="/developer" component={Home} exact />
			<Route path="/developer/about" component={About} />
			<Route path="/developer/contact" component={Contact} />
			<Route component={Error} />
		  </Switch>
		</BrowserRouter>
	  );
  
	}
  }
export default App;
